function daysInMonth(year, month) {
  return new Date(year, month, 0).getDate();
}

function canonicalDate(year, month, day) {
  const y = Number(year);
  const m = Number(month);
  const d = Number(day);
  if (!Number.isInteger(y) || y < 2000 || y > 2199) return '';
  if (!Number.isInteger(m) || m < 1 || m > 12) return '';
  const maxDay = daysInMonth(y, m);
  if (!Number.isInteger(d) || d < 1 || d > maxDay) return '';
  return `${String(y).padStart(4, '0')}-${String(m).padStart(2, '0')}-${String(d).padStart(2, '0')}`;
}

export function normalizeInventoryExpirationInput(value) {
  const text = String(value ?? '').trim();
  if (!text) return '';

  let match = /^(\d{1,2})\/(\d{4})$/.exec(text);
  if (match) {
    const month = Number(match[1]);
    const year = Number(match[2]);
    if (month < 1 || month > 12) return '';
    return canonicalDate(year, month, daysInMonth(year, month));
  }

  match = /^(\d{4})-(\d{1,2})$/.exec(text);
  if (match) {
    const year = Number(match[1]);
    const month = Number(match[2]);
    if (month < 1 || month > 12) return '';
    return canonicalDate(year, month, daysInMonth(year, month));
  }

  match = /^(\d{1,2})[\/-](\d{1,2})[\/-](\d{4})$/.exec(text);
  if (match) return canonicalDate(match[3], match[1], match[2]);

  match = /^(\d{4})-(\d{1,2})-(\d{1,2})(?:T.*)?$/.exec(text);
  if (match) return canonicalDate(match[1], match[2], match[3]);

  return '';
}

export function formatInventoryExpirationInput(value) {
  const text = String(value ?? '').trim();
  if (!text) return '';
  const normalized = normalizeInventoryExpirationInput(text);
  if (!normalized) return text;
  const [year, month, day] = normalized.split('-');
  return `${month}/${day}/${year}`;
}
